<template>
    
    <vs-dropdown style="float: right; cursor: pointer;" vs-custom-content vs-trigger-click>
      <vs-button color="primary" type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>

      <vs-dropdown-menu>
 
        <vs-dropdown-item @click="haldleDelete">Delete</vs-dropdown-item>
        
      </vs-dropdown-menu>
    </vs-dropdown>
</template>

<script>
import { taskTemplateDelete, taskDelete } from '@/api/task-project.js'
import { mapActions } from 'vuex'
export default {
  name: 'CellRendererActions',
 
  methods: {
    ...mapActions([
      'SET_DELETE_ID',
      'SET_DELETE_LIVE_ID'
    ]),
    async haldleDelete () {
    
      const deleting_id = this.params.data.id
      const payload = {
        deleteFields: [deleting_id]
      }
      if (this.params.data.reference_id === null || this.params.data.reference_id === '') {
        try {
          const data = await taskTemplateDelete(localStorage.getItem('customer_id'), payload)
          this.SET_DELETE_ID(deleting_id)
          this.$vs.notify({
            title: 'Task Deleted',
            text: 'Task Deleted Successfully',
            ...this.successProp()
          })
        } catch (error) {
          console.error(error)
          this.$vs.notify({
            title: 'Warning',
            text: error.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

        }
      } else {
        try {
          const data = await taskDelete(localStorage.getItem('customer_id'), payload)
          this.SET_DELETE_LIVE_ID(deleting_id)
          this.$vs.notify({
            title: 'Task Deleted',
            text: 'Task Deleted Successfully',
            ...this.successProp()
          })
        } catch (error) {
          console.error(error)
          this.$vs.notify({
            title: 'Warning',
            text: error.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

        }
      }
      
     
    }
  }
}


</script>